export default __webpack_public_path__ + "static/media/Line1.1c713548.svg";